// extracted by mini-css-extract-plugin
module.exports = {"head":"head_head__2HQ1L"};